module.exports = __webpack_public_path__ + "static/Branding-d94dab99e6d4e9eef0677f9dd6cd35cd.svg";